import {ActionWrapper, EButtonUiContext} from "/@lib@/commons/actions.js";
import {IPubCtx} from "/@lib@/wsp/wspMetaUi.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {GenAction} from "/@back@/wsp/views/gen/genActions.js";
import {ActionActions, OActionActionsInit} from "/@back@/commons/widgets/buttons.js";
import {Desk} from "/@lib@/commons/desk.js";
import {EGenStatus} from "/@lib@/wsp/item.js";

export class ShowPortalFrontsGenAction extends GenAction {

	constructor(protected frontsDescPath: string, id?: string) {
		super(id || "show");
		this._label = "Ouvrir";
		this._icon = "/@skin@/wsp/views/generators/show.svg";
		this._description = "Ouvrir l'environnement de test...";
		this._hideForStatuses = [EGenStatus.failed, EGenStatus.null];
	}

	async findFrontsUrl(ctx: IPubCtx): Promise<{ key: string, title: string, url: string }[]> {
		const urlPub = ctx.wsp.wspServer.config.pubUrl.resolve(ctx.genInfo.uriPub.substr(1));
		const resp: { fronts: { key: string, title: string, url: string }[] } = await urlPub.fetchJson<{ fronts: { key: string, title: string, url: string }[] }>(this.frontsDescPath);
		return resp.fronts;
	}

	buildCustomButton(ctx: IPubCtx, uiContext: EButtonUiContext, parent?: Element): Element | null | undefined {
		if (!this.isVisible(ctx)) return null;

		const actWeb = new GenAction().setLabel("Ouvrir dans un navigateur").setExecute(async (ctx1, ev) => {
			// FIXME : gérer le multi-fronts
			const fronts = await this.findFrontsUrl(ctx);
			window.open(fronts[0].url, '_blank');
			if (fronts.length > 1)
				console.log("TODO multi-fronts", fronts);
		});

		const actElectron = new GenAction().setLabel("Ouvrir dans une nouvelle fenêtre").setVisible((ctx) => Desk.electron).setExecute(async (ctx1, ev) => {
			// FIXME : gérer le multi-fronts
			const fronts = await this.findFrontsUrl(ctx);
			window.postMessage({type: "client:servers:open", url: fronts[0].url, name: `${fronts[0].title} - SCENARItest`, save: false, newWindow: {transient: true}}, location.origin);
			if (fronts.length > 1)
				console.log("TODO multi-fronts", fronts);
		});

		const actClipboard = new GenAction().setLabel("Copier l'URL dans le presse-papier").setExecute(async (ctx1, ev) => {
			// FIXME : gérer le multi-fronts
			const fronts = await this.findFrontsUrl(ctx);
			try {
				await navigator.clipboard.writeText(fronts[0].url);
			} catch (e) {
				POPUP.showNotifForbidden("Copie dans le presse-papier impossible. Vérifiez dans votre navigateur que vous avez autorisé ce site à accéder au presse-papier.", ctx.uiContext);
			}
			if (fronts.length > 1)
				console.log("TODO multi-fronts", fronts);
		});

		let mainAction: GenAction;
		let otherActions: GenAction[] = [];

		if (Desk.electron) {
			mainAction = actElectron;
			otherActions.push(actWeb, actClipboard);
		} else {
			mainAction = actWeb;
			otherActions.push(actClipboard);
		}

		return new ActionActions<IPubCtx>().initialize({
			reg: ctx.reg,
			actionContext: ctx,
			actionBtn: {
				action: new ActionWrapper().setOverridenSvc(mainAction)
					.setLabel(this.getLabel(ctx))
					.setIcon(this.getIcon(ctx))
			},
			actionsBtn: {
				actions: otherActions,
			},
			skinOver: "dialog/c-button",
			uiContext: uiContext,
		} as OActionActionsInit<IPubCtx>);
	}

	isVisible(ctx: IPubCtx): boolean {
		if (!ctx.genInfo.uriPub) return false;
		return super.isVisible(ctx);
	}

}
